import { Button, Col, Modal, Row } from "antd";
import React, { useContext } from "react";
import dayjs from "dayjs";
import LoaderContext from "../../Context/LoaderContext/Index";
import SlotCard from "./SlotCard";

interface SlotPickerModalProps {
  selectedDate: dayjs.Dayjs;
  handleSlotPickerModalClose: () => void;
  handleBookSlot: () => void;
  selectedSlot: any;
  slots: any[];
  handleSlotChange: (slot: any) => void;
}

const SlotPickerModal: React.FC<SlotPickerModalProps> = ({
  selectedDate,
  handleSlotPickerModalClose,
  handleBookSlot,
  selectedSlot,
  slots,
  handleSlotChange,
}) => {
  const { isLoading } = useContext(LoaderContext);

  const modalTitle = `Available Slots for ${dayjs(selectedDate).format(
    "MMMM D, YYYY"
  )}`;

  const filetredSlots = slots.filter((slot: any) =>
    dayjs(slot.start).isSame(selectedDate, "day")
  );

  return (
    <Modal
      title={modalTitle}
      closeIcon={null}
      open={!!selectedDate}
      onCancel={handleSlotPickerModalClose}
      footer={[
        <Button
          type="default"
          key="cancel"
          onClick={handleSlotPickerModalClose}
        >
          Cancel
        </Button>,
        <Button
          key="book"
          type="primary"
          disabled={!selectedSlot}
          onClick={handleBookSlot}
          loading={isLoading}
        >
          Book Slot
        </Button>,
      ]}
      centered
      width={"75vw"}
    >
      <Row
        gutter={[16, 16]}
        align={"middle"}
        justify={"center"}
        className="slot-picker-row"
      >
        {filetredSlots.map((slot: any, index: number) => (
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={filetredSlots.length > 4 ? 4 : 8}
            key={index}
          >
            <div
              style={{
                margin: "0 8px",
              }}
            >
              <SlotCard
                handleSlotChange={handleSlotChange}
                selectedSlot={selectedSlot}
                slot={slot}
              />
            </div>
          </Col>
        ))}
      </Row>
    </Modal>
  );
};

export default SlotPickerModal;
